import { DocPage, Section, SpecTable } from "../../components/DocChrome";

export function PagesPatternPage() {
    return (
        <DocPage
            title="Page Archetypes"
            description="Compose pages from shells + regions — do not invent new layouts per feature."
        >
            <Section title="Canonical structures">
                <SpecTable
                    rows={[
                        ["Dashboard", "PageHeader + KPI row + 1–2 charts/lists"],
                        ["List", "PageHeader + search/filters + Table + Pagination"],
                        ["Detail", "Breadcrumb + PageHeader + summary cards + tabs/sections"],
                        ["Create/Edit", "PageHeader + FormField stack + sticky primary actions"],
                        ["Wizard", "Stepper + single-task step + Back/Next"],
                        ["Settings", "Grouped sections; switches for preferences"],
                        ["History", "Merged or dual lists with clear timestamps"],
                        ["Empty / Error", "Centered EmptyState / ErrorState in content region"],
                    ]}
                />
            </Section>
        </DocPage>
    );
}
